<div *ngIf="devices.length > 0" class="flex flex-col mt-10">
  <div class="overflow-x-auto">
    <div class="inline-block min-w-full py-2 overflow-x-auto overflow-y-auto align-middle">
      <div class="overflow-hidden">
        <table class="min-w-full">
          <thead class="border-b border-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3 pl-0 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Status
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Nome
              </th>
              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Tipo de Dispositivo
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Empresa
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Identificador do Hardware
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Identificador do Equipamento
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Responsável
              </th>

              <th scope="col" class="px-6 py-3 font-bold tracking-wider text-left uppercase text-chathams-blue">
                Totem registrado
              </th>

              <th
                scope="col"
                class="px-6 py-3 font-bold tracking-wider text-center uppercase text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-iceberg" *ngFor="let device of devices">
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                <app-status-switch
                  [active]="device.active"
                  [itemName]="'dispositivo ' + device.name"
                  [enablePermissions]="[ERoleAdminString.Admin, 'device.enable']"
                  [disablePermissions]="[ERoleAdminString.Admin, 'device.disable']"
                  (toggle)="toogleDeviceStatus(device.id!, device.active)"
                ></app-status-switch>
              </td>
              <td class="px-6 py-4 font-medium text-md text-chathams-blue whitespace-nowrap">
                {{ device.name }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ device.deviceTypeName }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ device.companyName }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ device.hardwareId }}
              </td>
              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ device.equipmentId }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                {{ device.contactName }} <br />
                {{ device.contactPhone | mask: '(99) 99999-9999' }}
              </td>

              <td class="px-6 py-4 font-medium leading-4 tracking-wider text-md text-chathams-blue whitespace-nowrap">
                <ng-container *ngIf="kioskRegistrations[device.id] as registro">
                  <span data-testid="kiosk-estado">
                    {{
                      registro.revokedAt
                        ? 'Revogado em ' + (registro.revokedAt | date: 'dd/MM/yyyy HH:mm')
                        : 'Registrado'
                    }}
                  </span>
                  <br />
                  {{ registro.registeredByName || registro.registeredBy }} em
                  {{ registro.registeredAt | date: 'dd/MM/yyyy HH:mm' }}
                </ng-container>
              </td>

              <td
                class="flex justify-center flex-1 gap-2 px-6 py-4 whitespace-normal text-md text-chathams-blue"
                *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
              >
                <a
                  *isAllowed="[ERoleAdminString.Admin, 'device.edit']"
                  [routerLink]="'editar/' + device.id"
                  class="flex items-center justify-center w-8 h-8 rounded-full bg-iceberg"
                  [attr.aria-label]="'Editar dispositivo ' + device.name"
                  [title]="'Editar dispositivo ' + device.name"
                >
                  <lucide-icon name="pencil" [size]="18"></lucide-icon>
                </a>
                <button
                  *ngIf="kioskRegistrations[device.id] && !kioskRegistrations[device.id].revokedAt"
                  type="button"
                  class="flex items-center justify-center h-8 px-3 rounded-full bg-iceberg"
                  data-testid="revogar-registro"
                  (click)="revokeKioskRegistration(device)"
                >
                  Revogar registro
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<app-no-results-found [condition]="devices.length === 0"></app-no-results-found>

<div class="flex justify-end mb-5">
  <app-paginacao
    [numeroDeItens]="dadosPaginacao.itensTotal"
    [tamanhoDaPagina]="dadosPaginacao.tamanhoPagina"
    [paginaSelecionada]="dadosPaginacao.paginaSelecionada"
    [totalPage]="dadosPaginacao.totalPaginas"
    (mudouPagina)="mudouPagina.emit($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina.emit($event)"
  ></app-paginacao>
</div>
